import React from 'react';
import { motion } from 'framer-motion';
import { useApp } from '../context/AppContext';

export default function Header() {
  const { state, dispatch, currentUser } = useApp();
  const { view } = state;

  const nav = (v, userId) => dispatch({ type: 'SET_VIEW', payload: { view: v, userId } });

  return (
    <motion.header
      className="header"
      initial={{ y: -60 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
    >
      <div className="header-inner">
        {view !== 'feed' && (
          <button className="btn-back" onClick={() => nav('feed')}>
            ← 返回
          </button>
        )}
        <h1 className="header-title">
          {view === 'feed' && '朋友圈'}
          {view === 'profile' && '个人主页'}
          {view === 'edit-profile' && '编辑资料'}
        </h1>
        <div className="header-actions">
          {view === 'feed' && (
            <button
              className="btn-avatar"
              onClick={() => nav('profile', state.currentUserId)}
            >
              <div className="mini-avatar">
                {currentUser.avatar ? (
                  <img src={currentUser.avatar} alt="" />
                ) : (
                  <span>{currentUser.name[0]}</span>
                )}
              </div>
            </button>
          )}
        </div>
      </div>
    </motion.header>
  );
}
